import React from 'react';
import { TableRow, TableRowProps } from '@mui/material';
import type { SxProps, Theme } from '@mui/material/styles';

import { styles as tableStyles } from 'components/shared/CustomTable/stylesTable';
import { styles } from './styles';

const CustomTableRow = ({
  children,
  hover = true,
  sx,
  ...rest
}: TableRowProps) => {
  return (
    <TableRow
      hover={hover}
      sx={
        [styles.tableRow, hover && tableStyles.hover, sx] as SxProps<Theme>
      }
      {...rest}
    >
      {children}
    </TableRow>
  );
};

export default CustomTableRow;
